import * as React from 'react';

import loadable from '@loadable/component';
import Page from '../../../components/Page';
import { mpTrackingScreens } from '../../../config/screens';
import LoadingPage from '../../../components/LoadingPage';

const LoadableLandingPageNewV2 = loadable(() => import('../components/LandingPageNewV2'), {
    fallback: <LoadingPage isDark />,
});

class LazyLoadLanding extends React.Component {
    render() {
        return (
            <Page noCrawl={false} trackingScreen={mpTrackingScreens.landing}>
                <LoadableLandingPageNewV2 />
            </Page>
        );
    }
}

export default LazyLoadLanding;
